import React from "react"
import PlainLink from "../../../../../components/ui/link"
import {
  getArrayByIds,
  renderArrayOfNames,
} from "../../../../../library/utils/arrays"
import {
  grades as gradesList,
  subjects as subjectsList,
} from "../../../../../library/constants/educationalDictionary"
import * as routes from "../../../../../library/constants/routes"
import { generatePath } from "react-router-dom"

const KnowmixInfo = ({ knowmix }) => {
  const creatorName =
    !!knowmix && knowmix.creator_user
      ? `${knowmix.creator_user?.first_name} ${knowmix.creator_user?.last_name}`
      : knowmix.creator_group?.name

  const creatorUrl =
    !!knowmix && knowmix.creator_user
      ? generatePath(routes.USER, { userId: knowmix.creator_user?.id })
      : generatePath(routes.GROUP, { groupId: knowmix.creator_group?.id })

  const status = () => {
    if (knowmix.is_creator || knowmix.is_admin || knowmix.is_teacher) {
      // if (
      //   knowmix.product &&
      //   !knowmix.product.deleted &&
      //   !knowmix.product.blocked
      // ) {
      //   return "Public"
      // } else {
      //   return "Not public"
      // }
      if (knowmix.is_finished) {
        return "Released"
      } else {
        return "Not released"
      }
    } else {
      switch (knowmix.type) {
        case 1:
          return "Not started"

        case 2:
          return "Started"

        case 3:
          return "Finished"

        default:
          return "Not started"
      }
    }
  }
  return (
    <div className="box product-main-info--kx">
      <div className="box__content">
        <table className="product-main-info__table product-main-info__table--kx">
          <tbody>
            <tr>
              <td className="product-main-info__table-label pb8">Creator:</td>
              <td className="product-main-info__table-value pb8">
                <PlainLink to={creatorUrl} ellipsis>
                  {creatorName}
                </PlainLink>
              </td>
            </tr>

            {!!knowmix && !!knowmix.subjects.length && (
              <tr>
                <td className="product-main-info__table-label pb8">
                  Subjects:
                </td>
                <td
                  className="product-main-info__table-value pb8"
                  title={renderArrayOfNames(
                    getArrayByIds(subjectsList, knowmix.subjects)
                  )}
                >
                  {renderArrayOfNames(
                    getArrayByIds(subjectsList, knowmix.subjects)
                  )}
                </td>
              </tr>
            )}

            {!!knowmix && !!knowmix.grades.length && (
              <tr>
                <td className="product-main-info__table-label">Grades:</td>
                <td
                  className="product-main-info__table-value"
                  title={renderArrayOfNames(
                    getArrayByIds(gradesList, knowmix.grades)
                  )}
                >
                  {renderArrayOfNames(
                    getArrayByIds(gradesList, knowmix.grades)
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!!status().length && (
        <>
          <div className="h-divider h-divider--horizontal-margin"></div>
          <div className="box__content">
            <div className="product-price product-price--kx">{status()}</div>
          </div>
        </>
      )}
    </div>
  )
}

export default KnowmixInfo
